import React from 'react';
import { connect } from 'react-redux';
import { func } from 'prop-types';
import { OpportunitiesConst } from '@axiom/const';
import {
  Gutter,
  Modal,
  Button,
  ModalHeader,
  ModalSection,
  ModalFooter,
  CondensedLabel,
} from '@axiom/ui';
import { Field } from 'react-final-form';

import StoreStateTreatment from '../StoreStateTreatment/StoreStateTreatment';
import { EditOpportunityTalentTabStore } from '../../stores/edit-opportunity-talent-tab-store';
import { FormAutoCoolingModalStore } from '../../stores/form-auto-cooling-modal-store';
import { FFRichTextEditor } from '../FFRichTextEditor/FFRichTextEditor';

const AutoCoolingModalComponent = ({
  form,
  editOpportunityTalentTabStore,
  onCancel,
  onSend,
}) => {
  return (
    <StoreStateTreatment
      name="COOLING_MESSAGE_TREATMENT"
      isModalState
      storeState={editOpportunityTalentTabStore}
      renderLoadedView={({ data: editOpportunityTalentTabData }) => {
        return (
          <Modal>
            <ModalHeader onClose={onCancel}>Cooling Talent</ModalHeader>
            <ModalSection>
              <div data-test="AUTOCOOLINGFORM">
                <Gutter bottom="16px">
                  <CondensedLabel>
                    We'll send the following message to the talent directly to
                    let them know they've been cooled. To customize the message,
                    edit the text below before you click Send.
                  </CondensedLabel>
                </Gutter>
                <Field
                  name="candidateStatusMessage"
                  component={FFRichTextEditor}
                  initialValue={
                    form.coolingMessage ||
                    `Thank you for your time and interest in the opportunity with ${editOpportunityTalentTabData.opportunity.accountName}. They were impressed with your qualifications but are not moving forward with the role at this time. We still think you’re awesome and are actively working to find your next engagement.`
                  }
                />
              </div>
            </ModalSection>
            <ModalFooter>
              <Button
                className="cooling-talent-action"
                onClick={onCancel}
                name="COOLINGTALENTCANCELBUTTON"
                variation="outline"
              >
                Cancel
              </Button>
              <Button
                className="cooling-talent-action"
                onClick={onSend}
                name="COOLINGTALENTSENDBUTTON"
              >
                Send
              </Button>
            </ModalFooter>
          </Modal>
        );
      }}
    />
  );
};

AutoCoolingModalComponent.defaultProps = {};
AutoCoolingModalComponent.propTypes = {
  editOpportunityTalentTabStore:
    EditOpportunityTalentTabStore.getStateShape().isRequired,
  form: FormAutoCoolingModalStore.getDataShape().isRequired,
  onCancel: func.isRequired,
  onSend: func.isRequired,
};

export const AutoCoolingModal = connect(state => ({
  editOpportunityTalentTabStore: EditOpportunityTalentTabStore.select(state),
}))(AutoCoolingModalComponent);
